import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const FaceBookIcon = ({ color, fillOpacity, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      fillOpacity={fillOpacity}
      d="M21.2068 11.1579C21.2068 5.37989 16.5521 0.696777 10.8101 0.696777C5.06807 0.696777 0.413452 5.37989 0.413452 11.1579C0.413452 16.3781 4.21548 20.7055 9.18549 21.4901V14.1812H6.54626V11.1571H9.18549V8.85299C9.18549 6.23073 10.7382 4.78273 13.1123 4.78273C14.2499 4.78273 15.4396 4.98672 15.4396 4.98672V7.56104H14.1295C12.8385 7.56104 12.4356 8.36742 12.4356 9.19473V11.1579H15.3192L14.8582 14.1821H12.4356V21.4909C17.4056 20.7064 21.2076 16.3789 21.2076 11.1579H21.2068Z"
    />
  </svg>
);

FaceBookIcon.propTypes = {
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

FaceBookIcon.defaultProps = {
  fillOpacity: 1,
  ...helpers.getDefaultIconDimensionsProps(22, 22),
};

export default FaceBookIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/facebook.js